import {Organization} from '$share/types/organization'

export type ConnectOrg = Pick<
    Organization,
    'orgCode' | 'name' | 'displayName' | 'displayName2' | 'industry' | 'odr' | 'savings'
>

export enum ConsentRequestType {
    FirstAuth = '0',
    SecondAuth = '1',
    IndividualAuth = '2',
}
